<template>
  <div class="roleplay-home bg-base-100 min-h-screen text-base-content">
    <!-- Back button header -->

    <threads-nav show-back :show-center="false" />

    <!-- Main content -->
    <div v-if="!isInit" class="flex justify-center pt-20">
      <div class="loading loading-ring loading-lg"></div>
    </div>
    <template v-else>
      <div class="p-4">
        <template v-if="lastCategory && lastCategory.item">
          <div class="red-dot ml-2 text-base font-semibold mb-2">问题集</div>
          <div class="card bg-base-200 shadow-md mb-4">
            <div class="card-body p-4">
              <div class="flex items-center">
                <div class="flex flex-col flex-1">
                  <h2 class="text-lg font-bold text-left mb-2">
                    {{ lastCategory.item.name }}
                  </h2>
                  <p class="text-sm opacity-70">
                    {{
                      Math.round(
                        (lastCategory.item.answerProgressPercent! * 100) /
                          lastCategory.item.questionzzCount!
                      )
                    }}/{{ lastCategory.item.questionzzCount }}
                  </p>
                </div>
              </div>
              <div class="flex items-center gap-2 justify-between">
                <div class="flex items-center flex-col">
                  <div class="w-12">
                    <UserAvatar :mate="lastCategory.mate" />
                  </div>
                  <span class="text-sm opacity-70">
                    {{ useName(lastCategory.mate.name) }}
                  </span>
                </div>
                <button
                  class="btn btn-primary mt-4"
                  @click="
                    goToCategory(lastCategory.item.uuid, lastCategory.mate.uuid)
                  "
                >
                  继续答题
                </button>
              </div>
            </div>
          </div>
        </template>
        <!-- Sorting options -->

        <div class="red-dot ml-2 text-base font-semibold">问题集</div>
        <div class="flex items-center gap-2 mb-4 overflow-x-auto py-2">
          <boxed-tab
            :selected-idx="activeSortIdx"
            @update:selected-idx="onSorterChange"
          >
            <div v-for="(item, idx) in SORTER_ENUM" :key="idx">
              {{ item.text }}
            </div>
          </boxed-tab>
        </div>

        <!-- Question set cards -->
        <div class="grid grid-cols-2 gap-4">
          <RoleplayQuestionItem
            v-for="(item, index) in list"
            :key="index"
            :item="item"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  ApiGetRoleplayQuestionCategoryAll,
  ApiGetRoleplayQuestionCategoryLatestAnswered,
} from "@/apis/roleplay";
import { Mate, RoleplayQuestionCategory } from "@/types/entity";
import { useName } from "@/use/common";
const router = useRouter();
const list = ref<RoleplayQuestionCategory[]>([]);
const lastCategory = ref<{ mate: Mate; item: RoleplayQuestionCategory }>();

const SORTER_ENUM = [
  { text: "最近更新", value: 0 },
  { text: "完成度高→低", value: 1 },
  { text: "完成度低→高", value: 2 },
];

const activeSortIdx = ref(0);
const onSorterChange = (idx: number) => {
  activeSortIdx.value = idx;
  if (idx === 0) {
    list.value = list.value.sort(
      (a, b) => new Date(b.dtCreate).getTime() - new Date(a.dtCreate).getTime()
    );
  } else if (idx === 1) {
    list.value = list.value.sort(
      (a, b) => b.answerProgressPercent! - a.answerProgressPercent!
    );
  } else if (idx === 2) {
    list.value = list.value.sort(
      (a, b) => a.answerProgressPercent! - b.answerProgressPercent!
    );
  }
};

const goToCategory = (uuid: string, mateUuid?: string) => {
  router.push({
    name: "roleplayList",
    params: { uuid },
    query: { mateUuid },
  });
};

const isInit = ref(false);
// Fetch data from API
onMounted(async () => {
  try {
    isInit.value = false;
    // Get all question categories
    const categoriesResponse = await ApiGetRoleplayQuestionCategoryAll();

    list.value = categoriesResponse.itemzz;
    onSorterChange(activeSortIdx.value);

    // Get the last answered category
    const res = await ApiGetRoleplayQuestionCategoryLatestAnswered();
    if (res.data) {
      lastCategory.value = res.data;
    }
  } catch (error) {
    console.error("Failed to fetch roleplay categories", error);
    // Fallback to sample data
  } finally {
    isInit.value = true;
  }
});
</script>

<style scoped>
:deep(.van-tabs__wrap) {
  background-color: transparent;
}

:deep(.van-tabs__line) {
  background-color: var(--color-primary);
}

:deep(.van-tab--active) {
  font-weight: bold;
  color: var(--color-primary);
}
</style>
